<div style="background:#ffffff;border-radius:20px;overflow:hidden;position:relative;font-family:'Syne',sans-serif;">

    <style>
        @keyframes tmFadeUp {
            from { opacity: 0; transform: translateY(8px); }
            to   { opacity: 1; transform: translateY(0); }
        }
        .tm-fade { animation: tmFadeUp 0.22s ease forwards; }
    </style>

    <div style="height:2px;background:linear-gradient(90deg,#3b82f6,#6366f1,#8b5cf6)"></div>

    <!-- Header -->
    <div style="padding:1.5rem 1.75rem 1.25rem;display:flex;align-items:flex-start;justify-content:space-between;border-bottom:1px solid #f0f0f5">
        <div>
            <div style="font-size:10px;letter-spacing:.15em;text-transform:uppercase;color:#6366f1;font-weight:600;margin-bottom:4px">
                {{ config.subtitle }}
            </div>
            <div style="font-size:18px;font-weight:700;color:#0f0f1a;letter-spacing:-.02em">
                {{ config.title }}
            </div>
        </div>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>

    <!-- Body -->
    <div style="padding:1.5rem 1.75rem">

        <!-- User row — always visible, no animation needed -->
        <div style="display:flex;align-items:center;gap:12px;margin-bottom:1.5rem;padding-bottom:1.25rem;border-bottom:1px solid #f0f0f5">
            <div style="width:40px;height:40px;border-radius:12px;background:linear-gradient(135deg,#3b82f6,#8b5cf6);display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:700;color:#fff;flex-shrink:0">
                {{ (user.email?.[0] || user.username?.[0] || 'U').toUpperCase() }}
            </div>
            <div style="min-width:0">
                <div style="font-size:13px;font-weight:600;color:#0f0f1a">{{ user.email || user.username }}</div>
                <div style="font-size:11px;color:#9090a8;font-family:'JetBrains Mono',monospace;margin-top:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ user._id }}</div>
            </div>
            <span style="margin-left:auto;flex-shrink:0;display:inline-flex;align-items:center;gap:5px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:600;transition:all 0.3s ease"
                  [style]="tokenData?.is_active
                    ? 'background:#f0fdf4;color:#16a34a;border:1px solid #bbf7d0'
                    : 'background:#f5f5f8;color:#9090a8;border:1px solid #e8e8f0'">
                <span style="width:6px;height:6px;border-radius:50%;background:currentColor;display:inline-block"></span>
                {{ tokenData?.is_active ? 'Active' : 'No Token' }}
            </span>
        </div>

        <!-- Fixed-height content zone prevents modal shake -->
        <div style="min-height:220px;position:relative;">

            <!-- Loading shimmer -->
            <div *ngIf="isLoading" class="tm-fade" style="position:absolute;inset:0">
                <div style="display:flex;gap:10px;margin-bottom:10px">
                    <div *ngFor="let i of [1,2,3]" style="flex:1;height:52px;border-radius:12px;background:linear-gradient(90deg,#f5f5f8 25%,#ebebf5 50%,#f5f5f8 75%);background-size:200% 100%;animation:shimmer 1.4s infinite"></div>
                </div>
                <div style="height:64px;border-radius:14px;background:linear-gradient(90deg,#f5f5f8 25%,#ebebf5 50%,#f5f5f8 75%);background-size:200% 100%;animation:shimmer 1.4s infinite"></div>
            </div>

            <!-- Has token -->
            <div *ngIf="!isLoading && tokenData?.is_active" class="tm-fade">
                <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:1.25rem">
                    <div *ngIf="config.showCreatedDate" style="background:#f8f8fc;border:1px solid #ebebf5;border-radius:12px;padding:10px 12px">
                        <div style="font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#a0a0b8;font-weight:600;margin-bottom:4px">Created</div>
                        <div style="font-size:12px;font-weight:600;color:#1a1a2e">{{ tokenData?.created_at | date:'mediumDate' }}</div>
                    </div>
                    <div *ngIf="config.showLastUsed" style="background:#f8f8fc;border:1px solid #ebebf5;border-radius:12px;padding:10px 12px">
                        <div style="font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#a0a0b8;font-weight:600;margin-bottom:4px">Last used</div>
                        <div style="font-size:12px;font-weight:600;color:#1a1a2e">{{ tokenData?.last_used ? (tokenData?.last_used | date:'mediumDate') : '—' }}</div>
                    </div>
                    <div *ngIf="config.showExpiryDate" style="background:#f8f8fc;border:1px solid #ebebf5;border-radius:12px;padding:10px 12px">
                        <div style="font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#a0a0b8;font-weight:600;margin-bottom:4px">Expires</div>
                        <div style="font-size:12px;font-weight:600;color:#1a1a2e">{{ tokenData?.expires_at ? (tokenData?.expires_at | date:'mediumDate') : 'Never' }}</div>
                    </div>
                </div>

                <div style="background:#f8f8fc;border:1px solid #ebebf5;border-radius:14px;padding:14px;margin-bottom:10px">
                    <div style="font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#a0a0b8;font-weight:600;margin-bottom:10px">Current token</div>
                    <div style="display:flex;align-items:center;gap:8px">
                        <div style="flex:1;font-family:'JetBrains Mono',monospace;font-size:12px;color:#4f46e5;background:#eef2ff;border:1px solid #c7d2fe;border-radius:8px;padding:8px 12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:color 0.2s">
                            {{ revealToken ? (currentToken || tokenData?.token) : maskedToken }}
                        </div>
                        <button (click)="toggleReveal()"
                                style="width:34px;height:34px;flex-shrink:0;border-radius:8px;background:#fff;border:1px solid #e8e8f0;color:#9090a8;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.15s">
                            <i [class]="revealToken ? 'ph-eye-slash' : 'ph-eye'" style="font-size:14px"></i>
                        </button>
                        <button (click)="copyToken()"
                                style="width:34px;height:34px;flex-shrink:0;border-radius:8px;background:#fff;border:1px solid #e8e8f0;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.15s"
                                [style.color]="copySuccess ? '#16a34a' : '#9090a8'">
                            <i [class]="copySuccess ? 'ph-check' : 'ph-copy'" style="font-size:14px"></i>
                        </button>
                    </div>
                </div>
                <small style="font-size:11px;color:#b0b0c8;display:flex;align-items:center;gap:4px">
                    <i class="ph-info"></i> Full token only visible immediately after generation
                </small>
            </div>

            <!-- No token -->
            <div *ngIf="!isLoading && !tokenData?.is_active" class="tm-fade" style="text-align:center;padding:2rem 1rem">
                <div style="width:52px;height:52px;border-radius:16px;background:#f5f5f8;border:1px solid #ebebf5;display:flex;align-items:center;justify-content:center;margin:0 auto 14px">
                    <i class="ph-lock-key" style="font-size:22px;color:#c0c0d8"></i>
                </div>
                <div style="font-size:14px;font-weight:600;color:#606080;margin-bottom:6px">No API token</div>
                <div style="font-size:12px;color:#b0b0c8;line-height:1.5">
                    Generate a token to grant this user<br>programmatic API access.
                </div>
            </div>

        </div><!-- end fixed-height zone -->
    </div>

    <!-- Footer -->
    <div style="padding:1.25rem 1.75rem;border-top:1px solid #f0f0f5;display:flex;align-items:center;gap:8px;background:#fafafa">
        <button *ngIf="tokenData?.is_active"
                (click)="revokeToken()"
                [disabled]="isLoading"
                style="padding:8px 16px;font-size:13px;font-weight:600;border-radius:10px;cursor:pointer;background:#fff5f5;color:#dc2626;border:1px solid #fecaca;display:inline-flex;align-items:center;gap:6px;margin-right:auto;font-family:'Syne',sans-serif;transition:all 0.15s">
            <i class="ph-trash" style="font-size:13px"></i> {{ config.revokeButtonText }}
        </button>
        <button (click)="closeModal()"
                style="padding:8px 16px;font-size:13px;font-weight:600;border-radius:10px;cursor:pointer;background:#fff;color:#6060a0;border:1px solid #e8e8f0;font-family:'Syne',sans-serif;transition:all 0.15s">
            Cancel
        </button>
        <button (click)="generateToken()"
                [disabled]="isLoading"
                style="padding:8px 16px;font-size:13px;font-weight:600;border-radius:10px;cursor:pointer;background:linear-gradient(135deg,#3b82f6,#6366f1);color:#fff;border:none;display:inline-flex;align-items:center;gap:6px;font-family:'Syne',sans-serif;transition:opacity 0.15s">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
            <i *ngIf="!isLoading" class="ph-key" style="font-size:13px"></i>
            {{ tokenData?.is_active ? 'Regenerate' : config.generateButtonText }}
        </button>
    </div>

</div>